import { useMemo } from "react";
import KeycloakManager from "../services/keycloak";

export enum ROLES {
  ADMIN = "admin",
  ORG_ADMIN = "org-admin",
  USER = "user",
  UPLOAD = "upload",
  API_KEYS = "api-keys-user",
}

export const useRoles = () => {
  const tokenParsed = KeycloakManager.getTokenParsed();

  return useMemo(() => {
    const roles = tokenParsed?.realm_access?.roles || [];
    const operators = tokenParsed ? KeycloakManager.getTokenOperators() : [];
    return { roles, operators };
  }, [tokenParsed]);
};
